<template>
  <v-dialog
    width="800"
    persistent
    @input="onClose"
    :value="dialog"
    scrollable>
    <v-card>
      <v-card-title>
        <h1 class="text-h4 mx-auto">Select 🐶</h1>
          <v-btn
            class="closeButton"
            @click="onClose()"
            icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-2 px-sm-6">
        <v-row  no-gutters justify="center">
          <v-col
            cols="12" sm="6" v-for="(item, index) in purchaseDetails" :key="index"
            class="mb-4">
            <v-hover v-slot="{hover}">
              <v-card
                class="jindoCard rounded-lg py-4 mx-1 fill-height text-center"
                :elevation="hover ? 16 : 2"
                :class="{'on-hover': hover, 'gradient' : item.class}"
                @click="productLink(item)"
                :disabled="item.status === 'disabled'"
                color="grey darken-4">
                <v-img
                  style="margin: auto"
                  :width="item.size"
                  :height="item.size"
                  class="mb-2"
                  :src="require(`@/assets/${item.img}`)"
                  :lazy-src="require(`@/assets/${item.img}`)">
                </v-img>
                <template v-if="item.url === 'getjindo'">
                  <span>Ends May 31 2021, GMT+9</span>
                </template>
                <template v-else>
                  <span>{{item.details}}</span>
                </template>
                <v-card-actions class="justify-center py-4">
                  <v-btn
                    rounded
                    outlined>
                    {{item.title}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <h1 class="pb-4 body-1 text-center grey--text">Select your $JINDO that suits you the best 🤘</h1>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import urlCheck from '@/utils/urlCheck'

export default {
  props: {
    dialog: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    purchaseDetails: [
      {
        title: 'Coming soon', // Buy from Uniswap
        img: 'brand-logos/uniswap-uni-logo.svg',
        url: '', // https://app.uniswap.org
        size: '180',
        details: 'For announcement follow twitter @jindocoin',
        class: 'gradient',
        status: 'disabled'
      },
      {
        title: 'Win Free coins',
        img: 'jindo-free-coin.png',
        url: 'getjindo',
        size: '180',
        status: 'active'
      }
    ]
  }),
  computed: {
    //
  },
  methods: {
    productLink (selected) {
      if (selected.status === 'active') {
        const urlValid = urlCheck(selected.url)
        if (urlValid) window.open(selected.url, '_blank')
        else {
          this.$emit('dismissed')
          this.$router.push(selected.url)
        }
      }
    },
    onClose () {
      this.$emit('dismissed')
      this.$router.replace({ query: null })
    }
  }
}
</script>

<style scoped>
  .closeButton {
    position: absolute;
    right: 28px;
  }
  .gradient {
    background: rgb(255,159,193);
    background: radial-gradient(circle, rgba(255,159,193,1) 0%, rgba(148,187,233,1) 100%);
  }
  .jindoCard {
    transition: opacity 0.2s ease-in-out;
  }
  .jindoCard:not(.on-hover) {
    opacity: 0.8;
  }
</style>
